import React, { useEffect, useContext, useState, useId } from "react";
import { CuestionContext } from "../context/CuestionContext";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import "../styles/MisCuestionarios.css";
import { useTranslation } from "react-i18next";

export default function RespuestasMultiples( {preguntaActual} ) {

    const { t } = useTranslation();
    const autocompleteId = useId();
    const { respuestaSeleccionada, setRespuestaSeleccionada } = useContext(CuestionContext);
    const [respuestasSeleccionadas, setRespuestasSeleccionadas] = useState(preguntaActual && preguntaActual.respuestas ? preguntaActual.respuestas.filter(r => r.selecionada) : null)
    useEffect(() => {
        if (preguntaActual && preguntaActual.respuestas) {
            const s = preguntaActual.respuestas.filter(r => r.selecionada)
            setRespuestasSeleccionadas(s)
            setRespuestaSeleccionada(s.length > 0 ? s : null)
        }
    },[preguntaActual, setRespuestaSeleccionada])
    
    return (
        <>
            {preguntaActual && preguntaActual.respuestas && (
                <Autocomplete
                    className="test"
                    multiple
                    //TODO : Esto es una mierda pero funciona
                    id={autocompleteId}
                    // id={""+preguntaActual.id_pregunta+""}
                    options={preguntaActual.respuestas}
                    getOptionLabel={(option) => option.texto}
                    onChange={(event, newValue) => {
                        setRespuestasSeleccionadas(newValue);
                        setRespuestaSeleccionada(newValue.length > 0 ? newValue : null)
                    }}
                    value={respuestasSeleccionadas}
                    filterSelectedOptions
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder={t("cuestion.placeHolderMulti")}
                        />
                    )}
                />
            )}
        </>
  );
}
